import Profile_Avatar0 from 'styles/assets/avatar/Profile_Avatar0.png';
import Profile_Avatar1 from 'styles/assets/avatar/Profile_Avatar1.png';
import Profile_Avatar2 from 'styles/assets/avatar/Profile_Avatar2.png';
import Profile_Avatar3 from 'styles/assets/avatar/Profile_Avatar3.png';
import Profile_Avatar4 from 'styles/assets/avatar/Profile_Avatar4.png';
import Profile_Avatar5 from 'styles/assets/avatar/Profile_Avatar5.png';
import Profile_Avatar6 from 'styles/assets/avatar/Profile_Avatar6.png';
import Profile_Avatar7 from 'styles/assets/avatar/Profile_Avatar7.png';
import Profile_Avatar8 from 'styles/assets/avatar/Profile_Avatar8.png';
import Profile_Avatar9 from 'styles/assets/avatar/Profile_Avatar9.png';
import Profile_Avatar10 from 'styles/assets/avatar/Profile_Avatar10.png';
import Profile_Avatar11 from 'styles/assets/avatar/Profile_Avatar11.png';
import Profile_Avatar12 from 'styles/assets/avatar/Profile_Avatar12.png';
import Profile_Avatar13 from 'styles/assets/avatar/Profile_Avatar13.png';
import Profile_Avatar14 from 'styles/assets/avatar/Profile_Avatar14.png';
import Profile_Avatar15 from 'styles/assets/avatar/Profile_Avatar15.png';
import Profile_Avatar16 from 'styles/assets/avatar/Profile_Avatar16.png';
import Profile_Avatar17 from 'styles/assets/avatar/Profile_Avatar17.png';
import Profile_Avatar18 from 'styles/assets/avatar/Profile_Avatar18.png';
import Profile_Avatar19 from 'styles/assets/avatar/Profile_Avatar19.png';
import Profile_Avatar20 from 'styles/assets/avatar/Profile_Avatar20.png';
import Profile_Avatar21 from 'styles/assets/avatar/Profile_Avatar21.png';
import Profile_Avatar22 from 'styles/assets/avatar/Profile_Avatar22.png';
import Profile_Avatar23 from 'styles/assets/avatar/Profile_Avatar23.png';

export const avatar = {
    '/Profile_Avatar0.png' : Profile_Avatar0,
    '/Profile_Avatar1.png' : Profile_Avatar1,
    '/Profile_Avatar2.png' : Profile_Avatar2,
    '/Profile_Avatar3.png' : Profile_Avatar3,
    '/Profile_Avatar4.png' : Profile_Avatar4,
    '/Profile_Avatar5.png' : Profile_Avatar5,
    '/Profile_Avatar6.png' : Profile_Avatar6,
    '/Profile_Avatar7.png' : Profile_Avatar7,
    '/Profile_Avatar8.png' : Profile_Avatar8,
    '/Profile_Avatar9.png' : Profile_Avatar9,
    '/Profile_Avatar10.png' : Profile_Avatar10,
    '/Profile_Avatar11.png' : Profile_Avatar11,
    '/Profile_Avatar12.png' : Profile_Avatar12,
    '/Profile_Avatar13.png' : Profile_Avatar13,
    '/Profile_Avatar14.png' : Profile_Avatar14,
    '/Profile_Avatar15.png' : Profile_Avatar15,
    '/Profile_Avatar16.png' : Profile_Avatar16,
    '/Profile_Avatar17.png' : Profile_Avatar17,
    '/Profile_Avatar18.png' : Profile_Avatar18,
    '/Profile_Avatar19.png' : Profile_Avatar19,
    '/Profile_Avatar20.png' : Profile_Avatar20,
    '/Profile_Avatar21.png' : Profile_Avatar21,
    '/Profile_Avatar22.png' : Profile_Avatar22,
    '/Profile_Avatar23.png' : Profile_Avatar23
};